<template>
  <div class="col-12 g c col-lg-4">
    <br><br>
    <div class="card card-body">
        <img :src="require('@/assets/images/banner.png')" style="width: 300px; margin: 0px auto; padding: 20px" alt="">
        <div class="alert alert-danger text-center g" v-if="error">
            {{ error }}
        </div>
        <div class="form-group g">
          <h4 for="">الجوال</h4>
          <input type="text"
            class="form-control form-control-lg" placeholder="اكتب هنا..." v-model="phone">
        </div>
        <div class="form-group g">
          <h4 for="">كلمة المرور</h4>
          <input type="password"
            class="form-control form-control-lg"  placeholder="اكتب هنا..." v-model="password">
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="login()">
                تسجيل الدخول
                <i class="fa fa-arrow-left"></i>
            </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    created(){

    },
    data(){
        return {
            phone: "",
            password: "",
            error: null
        }
    },
    methods: {
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/admin/login', {
                phone: g.phone,
                password: g.password
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("user", JSON.stringify(r.response))
                    window.location = '/'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>

<style>

</style>